import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { NpsCategoryBadge, NpsStatusBadge } from './FeedbackBadges';
import { formatDate } from '../../../../utils/Utils';

/**
 * Formata uma data 'Y-m-d H:i:s' usando formatDate() do projeto.
 * @param {string|null} dateStr
 * @returns {string}
 */
function fmtDate(dateStr) {
  if (!dateStr) return '—';
  const date = new Date(dateStr.replace(' ', 'T'));
  if (Number.isNaN(date.getTime())) return '—';
  return formatDate(date);
}

/**
 * NpsRow - Linha da tabela de avaliações NPS (Admin Geral)
 * @param {Object} props
 * @param {Object} props.item
 * @param {Function} props.onView
 */
function NpsRow({ item, onView }) {
  const {
    id,
    rating,
    category,
    comments,
    user_name,
    user_email,
    company_name,
    screen,
    status,
    created_at,
  } = item;

  const handleView = () => {
    if (onView) onView(id);
  };

  return (
    <TableRow hover sx={{ cursor: 'pointer', '&:hover': { bgcolor: 'action.hover' } }} onClick={handleView}>
      <TableCell>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 700, color: 'text.primary' }}>
            {rating}/10
          </Typography>
          <NpsCategoryBadge category={category} />
        </Box>
      </TableCell>

      <TableCell>
        <Typography variant="body2" sx={{ color: 'text.primary', maxWidth: 280 }} noWrap>
          {comments || '—'}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2" sx={{ color: 'text.primary' }}>{user_name || '—'}</Typography>
        {user_email && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
            {user_email}
          </Typography>
        )}
      </TableCell>

      <TableCell>
        <Typography variant="body2">{company_name || '—'}</Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2" color="text.secondary">{screen || '—'}</Typography>
      </TableCell>

      <TableCell>
        <NpsStatusBadge status={status} />
      </TableCell>

      <TableCell>
        <Typography variant="body2" sx={{ color: 'text.primary' }}>{fmtDate(created_at)}</Typography>
      </TableCell>

      <TableCell align="right" onClick={(e) => e.stopPropagation()}>
        <Tooltip title="Ver detalhes">
          <IconButton size="small" onClick={handleView} sx={{ color: 'text.secondary' }}>
            <VisibilityOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
}

export default NpsRow;
